// Home.js
import React from "react";
import photo1 from "../assets/abbie-1.jpg";
import useAnimation from "../components/useAnimation";
import HomeNavbar from "../components/HomeNavbar";

const Home = () => {
  const isAnimating = useAnimation(1500);
  return (
    <div>
      {isAnimating && (
        <div className="fixed inset-0 bg-darkBrown z-50 animate-slideDown"></div>
      )}

      <div className="pt-14 w-full h-full top-0  md:fixed md:left-8 md:w-2/5 md:p-10 md:min-h-screen md:flex md:items-center  ">
        <div className="text-lg md:text-xl md:ml-16 md:pb-[8rem]  ">
          <div className="flex flex-row">
            <img
              src={photo1}
              style={{
                width: "50%",
                height: "auto",
                borderRadius: "100px 200px 90px 160px",
              }}
              alt="Abbie"
              className="ml-4"
            />
            <div className="flex flex-col my-auto mx-auto font-black  md:hidden">
              <p className="text-lg pb-2">This is </p>
              <h1 className="pb-2 text-6xl">Abbie</h1>
              <h1 className="pl-12 text-4xl">Yu Luo</h1>
            </div>
          </div>

          <div className="mx-6 font-base">
            <h1 className="pt-4 font-black hidden md:block md:text-3xl">
              Abbie - Yu Luo
            </h1>
            <div className="pt-4 px-8 md:px-1">
              <p>Front-End Software Engineer</p>
              <p>Currently looking for a full-time job.</p>
            </div>
            <div className="flex flex-col items-center justify-center  md:hidden">
              <p className="text-xl font-black text-deepBeige">
                - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </p>
              <HomeNavbar />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Home;
